import React from "react";
import { Lightbulb, Target, Clock, MousePointerClick, ListOrdered, AlertTriangle } from "lucide-react";
import AcademyModal from "./AcademyModal";
import { useAcademy } from "./AcademyContext";

// Sezioni fisse della guida contestuale: stesse per ogni pagina, così
// l'utente impara a orientarsi una volta sola e ritrova sempre la stessa
// struttura, indipendentemente da quale pagina la apre.
function Section({ icon: Icon, title, children }) {
  if (!children || (Array.isArray(children) && children.length === 0)) return null;
  return (
    <div className="border-b border-hairline py-3 last:border-0">
      <div className="flex items-center gap-2 text-sm font-semibold text-navy"><Icon className="h-4 w-4 text-gold" /> {title}</div>
      <div className="mt-1.5 text-sm leading-relaxed text-slate-600">{children}</div>
    </div>
  );
}

export default function GuideModal() {
  const { content, guideOpen, closeGuide } = useAcademy();
  const guide = content?.guide;
  return (
    <AcademyModal open={guideOpen} onClose={closeGuide} icon={<Lightbulb className="h-5 w-5" />} title={content?.title || "Guida"} subtitle="Guida contestuale">
      {!guide ? (
        <p className="text-sm text-slate-500">Guida non ancora disponibile per questa pagina.</p>
      ) : (
        <div>
          <Section icon={Target} title="A cosa serve">{guide.purpose}</Section>
          <Section icon={Clock} title="Quando usarla">{guide.when_to_use}</Section>
          {guide.buttons?.length > 0 && (
            <Section icon={MousePointerClick} title="Significato dei pulsanti">
              <ul className="space-y-1.5">
                {guide.buttons.map((btn, i) => (
                  <li key={i}><strong className="text-navy">{btn.label}:</strong> {btn.meaning}</li>
                ))}
              </ul>
            </Section>
          )}
          {guide.procedure?.length > 0 && (
            <Section icon={ListOrdered} title="Procedura">
              <ol className="list-decimal space-y-1 pl-4">
                {guide.procedure.map((step, i) => <li key={i}>{step}</li>)}
              </ol>
            </Section>
          )}
          {(guide.errors?.length > 0 || guide.tips?.length > 0) && (
            <Section icon={AlertTriangle} title="Errori comuni e consigli">
              <ul className="list-disc space-y-1 pl-4">
                {guide.errors?.map((e, i) => <li key={`e${i}`}>{e}</li>)}
                {guide.tips?.map((t, i) => <li key={`t${i}`} className="text-slate-500">{t}</li>)}
              </ul>
            </Section>
          )}
        </div>
      )}
    </AcademyModal>
  );
}
